import { getExternalToken } from "../../authority"

export async function getAuthenticationToken() {
    const response = await getExternalToken("FastUp")
    return `${response.schema} ${response.token}`
}
